module.exports = __webpack_public_path__ + "static/media/file-contract.0962af01.svg";